export const PROJECT_ROLE_LABELS = {
    viewer: 'Viewer (alleen lezen)',
    editor: 'Editor (schrijven, geen send)',
    sender: 'Sender (campagnes starten)',
    admin: 'Admin (volledig)',
};
export function normalizeProjectRole(role) {
    switch (role) {
        case 'viewer':
        case 'read_only':
            return 'viewer';
        case 'editor':
        case 'sales':
            return 'editor';
        case 'sender':
        case 'marketing':
            return 'sender';
        case 'admin':
        case 'owner':
            return 'admin';
        default:
            return 'viewer';
    }
}
export function projectCapabilitiesFromRole(rawRole) {
    const role = normalizeProjectRole(rawRole);
    const base = {
        role,
        leads_read: true,
        leads_write: false,
        campaigns_draft: false,
        campaigns_start: false,
        automations_read: true,
        automations_write: false,
        webhooks_manage: false,
        settings_manage: false,
        members_manage: false,
        copilot_actions_read: true,
        copilot_actions_approve: false,
        copilot_actions_execute: false,
    };
    if (role === 'viewer')
        return base;
    if (role === 'editor') {
        return {
            ...base,
            leads_write: true,
            campaigns_draft: true,
            automations_write: true,
            settings_manage: true,
            copilot_actions_read: true,
            copilot_actions_approve: false,
            copilot_actions_execute: true,
        };
    }
    if (role === 'sender') {
        return {
            ...base,
            leads_write: true,
            campaigns_draft: true,
            campaigns_start: true,
            automations_write: true,
            settings_manage: true,
            copilot_actions_read: true,
            copilot_actions_approve: true,
            copilot_actions_execute: true,
        };
    }
    return {
        role: 'admin',
        leads_read: true,
        leads_write: true,
        campaigns_draft: true,
        campaigns_start: true,
        automations_read: true,
        automations_write: true,
        webhooks_manage: true,
        settings_manage: true,
        members_manage: true,
        copilot_actions_read: true,
        copilot_actions_approve: true,
        copilot_actions_execute: true,
    };
}
export function capabilityDeniedMessage(cap) {
    const need = {
        leads_read: 'viewer',
        leads_write: 'editor',
        campaigns_draft: 'editor',
        campaigns_start: 'sender',
        automations_read: 'viewer',
        automations_write: 'editor',
        webhooks_manage: 'admin',
        settings_manage: 'editor',
        members_manage: 'admin',
        copilot_actions_read: 'viewer',
        copilot_actions_approve: 'sender',
        copilot_actions_execute: 'editor',
    };
    return `Geen rechten (${need[cap]} vereist)`;
}
//# sourceMappingURL=projectRbac.js.map